import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { TranslationService } from '@sdbn/common';
import { HttpService } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { AddProject } from '../../project.model';
import { MasterDetailListEntry } from '@sdbn/common';

class ListEntry implements MasterDetailListEntry {
  listTitle: string;
  listTitleDictionaryKey: string;
  listSubTitle: string;
  childs: MasterDetailListEntry[];
  groupIdentifier: String;

  constructor(dictionaryKey: string) {
    this.listTitleDictionaryKey = dictionaryKey;
  }

}

@Component({
  selector: 'app-add-project-dialog',
  templateUrl: './add-project-dialog.component.html',
  styleUrls: ['./add-project-dialog.component.scss']
})
export class AddProjectDialogComponent {

  readonly TAB_INDEX_SELECT_PROJECT = 0;
  readonly TAB_INDEX_ADD_PROJECT = 1;

  listEntries = [
    new ListEntry('erp.ui.add-project.tab.search.title')
    , new ListEntry('erp.ui.add-project.tab.create.title')
  ];
  selectedIndex = 0;
  selectedEntry = this.listEntries[0];

  constructor(
    public translationService: TranslationService,
    public dialogRef: MatDialogRef<AddProjectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

  }

  handleSelectionChange(selection: MasterDetailListEntry) {
    this.selectedEntry = selection;
    this.selectedIndex = this.listEntries.indexOf(this.selectedEntry);
  }

  onCancel() {
    this.dialogRef.close();
  }

  onProjectAdded(projectId: number) {
    this.dialogRef.close(projectId);
  }

}
